<template>
  <MainLayout :title="trans('Favorites')">
    <div
      class="sticky top-0 z-10 bg-theme-background"
      style="padding-top: var(--safe-area-inset-top)"
    >
      <div class="flex items-center p-4">
        <ADeepCircleButton
          class="flex-shrink-0"
          @click="router.push({ name: 'menu' })"
        >
          <template #icon><ArrowLeftBold /></template>
        </ADeepCircleButton>
        <div
          class="flex-1 truncate px-4 text-center font-primary text-lg font-medium"
        >
          {{ trans('Favorites') }}
        </div>
        <div class="h-10 w-10 flex-shrink-0"></div>
      </div>
    </div>
    <div class="p-4 pb-8">
      <div>
        <ProductCards
          :products="favoriteProductsStore.favoriteProducts"
          :override-display-type="DisplayType.LIST"
        />
      </div>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from '@menu/Shared/MainLayout.vue';
import ADeepCircleButton from '@menu/Shared/ADeepCircleButton.vue';
import ProductCards from '@menu/Shared/ProductCards.vue';
import ArrowLeftBold from '@/phosphoricons/ArrowLeftBold.vue';
import { trans } from '@menu/Utils/i18n';
import { DisplayType } from '@menu/Types/Enums/DisplayType';
import { useFavoriteProductsStore } from '@menu/Stores/favoriteProducts';
import { useRouter } from 'vue-router';

const router = useRouter();

const favoriteProductsStore = useFavoriteProductsStore();
</script>
